import { Vue, Options } from 'vue-class-component';
import Step0GeneralProperties from './Step0GeneralProperties/Step0GeneralProperties.vue';
import Step0WorkingMode from './Step0WorkingMode/Step0WorkingMode.vue';
import Step1AssignThermostat from './Step1AssignThermostat/Step1AssignThermostat.vue';
import Step2AssignTheProbe from './Step2AssignTheProbe/Step2AssignTheProbe.vue';
import StepAssignTheSharedActuator from './StepAssignTheSharedActuator/StepAssignTheSharedActuator.vue';
import StepAssignTheSharedPump from './StepAssignTheSharedPump/StepAssignTheSharedPump.vue';
import StepChooseSystemToControlType from './StepChooseSystemToControlType/StepChooseSystemToControlType.vue';
import StepAssignTheHeatingActuator from './StepAssignTheHeatingActuator/StepAssignTheHeatingActuator.vue';
import StepAssignTheHeatingPump from './StepAssignTheHeatingPump/StepAssignTheHeatingPump.vue';
import StepAssignTheCoolingActuator from './StepAssignTheCoolingActuator/StepAssignTheCoolingActuator.vue';
import StepAssignTheCoolingPump from './StepAssignTheCoolingPump/StepAssignTheCoolingPump.vue';
import StepThermostatPreferences from './StepThermostatPreferences/StepThermostatPreferences.vue';
import StepOverview from './StepOverview/StepOverview.vue';
import {
  ActuatorModalityType,
  EditThermoRoomObjectDTO,
  IEditThermoRoomObjectDTO,
  IThermoRoomObjectDTO,
  SystemControlType,
  ThermoAssociatedPump,
  ThermoRoomObjectDTO,
  ThermoTypeOfObject,
} from '@/../client-generator/generated-clients/plants';
import plantsClient from '@/core/services/plants';
import { SET_APP_LOADING } from '@/core/store/action-types';
import { DefaultDevicesSettingsDTO } from 'client-generator/generated-clients/device-settings';
import DeviceSettingsService from '@/core/services/device-settings-services/device-settings-service';
import { HANDLE_REFRESH_PLANT } from '@/core/utils/emitter-events';
import { NamingService } from '../../../../../core/services/naming.service';

@Options({
  name: 'ThermoWizard',
  components: {
    Step0GeneralProperties,
    Step0WorkingMode,
    Step1AssignThermostat,
    Step2AssignTheProbe,
    StepAssignTheSharedActuator,
    StepAssignTheSharedPump,
    StepChooseSystemToControlType,
    StepAssignTheHeatingActuator,
    StepAssignTheHeatingPump,
    StepAssignTheCoolingActuator,
    StepAssignTheCoolingPump,
    StepThermostatPreferences,
    StepOverview,
  },
})
export default class ThermoWizard extends Vue {
  activeStep = 0;
  roomObject: IThermoRoomObjectDTO = {};
  devicesSettings: DefaultDevicesSettingsDTO[] = [];
  plantId = -1;
  roomId = '';
  roomName = '';
  roomType: number = null!;
  roomObjectId = '';
  nextDisabled = false;

  get steps() {
    return [
      {
        title: 'AppResource.NameAndProperties',
        componentName: 'Step0GeneralProperties',
        show: true,
        preStep: true,
      },
      {
        title: 'AppResource.ActuatorsModality',
        componentName: 'Step0WorkingMode',
        show: this.isModeHeatingCooling,
        preStep: true,
      },
      {
        title: 'AppResource.AssignTheThermostat',
        componentName: 'Step1AssignThermostat',
        show: true,
      },
      {
        title: 'AppResource.AssignTheProbe',
        componentName: 'Step2AssignTheProbe',
        show: true,
      },
      {
        title: 'AppResource.TypeOfSharedSystem',
        componentName: 'StepChooseSystemToControlType',
        show: this.isModeHeatingCooling && this.isModeShared,
        customParams: {
          [StepChooseSystemToControlType.CHOOSE_TYPE_FIELD]:
            StepChooseSystemToControlType.CHOOSE_TYPES.SHARED,
        },
      },
      {
        title: 'AppResource.AssignTheSharedActuator',
        componentName: 'StepAssignTheSharedActuator',
        show: this.isModeHeatingCooling && this.isModeShared,
        disabled: this.isHeatingGatewayMode,
      },
      {
        title: 'AppResource.AssignTheSharedPump',
        componentName: 'StepAssignTheSharedPump',
        show:
          this.isModeHeatingCooling &&
          this.isModeShared &&
          this.isModeAssociatedPump,
        disabled: this.isHeatingGatewayMode,
      },
      {
        title: 'AppResource.ChooseTypeHeating',
        componentName: 'StepChooseSystemToControlType',
        show:
          this.isModeHeating ||
          (this.isModeHeatingCooling && !this.isModeShared),
        customParams: {
          [StepChooseSystemToControlType.CHOOSE_TYPE_FIELD]:
            StepChooseSystemToControlType.CHOOSE_TYPES.HEATING,
        },
      },
      {
        title: 'AppResource.AssignTheHeatingActuator',
        componentName: 'StepAssignTheHeatingActuator',
        show:
          this.isModeHeating ||
          (this.isModeHeatingCooling && !this.isModeShared),
        disabled: this.isHeatingGatewayMode,
      },
      {
        title: 'AppResource.AssignTheHeatingPump',
        componentName: 'StepAssignTheHeatingPump',
        show:
          (this.isModeHeating ||
            (this.isModeHeatingCooling && !this.isModeShared)) &&
          this.isModeAssociatedPump,
        disabled: this.isHeatingGatewayMode,
      },
      {
        title: 'AppResource.ChooseTypeCooling',
        componentName: 'StepChooseSystemToControlType',
        show:
          this.isModeCooling ||
          (this.isModeHeatingCooling && !this.isModeShared),
        customParams: {
          [StepChooseSystemToControlType.CHOOSE_TYPE_FIELD]:
            StepChooseSystemToControlType.CHOOSE_TYPES.COOLING,
        },
      },
      {
        title: 'AppResource.AssignTheCoolingActuator',
        componentName: 'StepAssignTheCoolingActuator',
        show:
          this.isModeCooling ||
          (this.isModeHeatingCooling && !this.isModeShared),
        disabled: this.isCoolingGatewayMode,
      },
      {
        title: 'AppResource.AssignTheCoolingPump',
        componentName: 'StepAssignTheCoolingPump',
        show:
          (this.isModeCooling ||
            (this.isModeHeatingCooling && !this.isModeShared)) &&
          this.isModeAssociatedPump,
        disabled: this.isCoolingGatewayMode,
      },
      {
        title: 'AppResource.ThermostatPreferences',
        componentName: 'StepThermostatPreferences',
        show: true,
      },
      {
        title: 'AppResource.EndTheConfiguration',
        componentName: 'StepOverview',
        show: true,
      },
    ].filter((k) => k.show);
  }

  get preSteps() {
    return this.steps.filter((k) => k.preStep);
  }

  get realSteps() {
    return this.steps.filter((k) => !k.preStep);
  }

  get disabledStepNumbers() {
    const stepNumbers: number[] = [];
    this.steps
      .filter((x) => !x.preStep)
      .forEach((element, index) => {
        if (element.disabled) stepNumbers.push(index + 1);
      });
    return stepNumbers;
  }

  get isModeHeating() {
    return this.roomObject.thermoTypeOfObject === ThermoTypeOfObject.Heating;
  }

  get isModeCooling() {
    return this.roomObject.thermoTypeOfObject === ThermoTypeOfObject.Cooling;
  }

  get isModeHeatingCooling() {
    return (
      this.roomObject.thermoTypeOfObject ===
      ThermoTypeOfObject.HeatingAndCooling
    );
  }

  get isModeAssociatedPump() {
    return this.roomObject.thermoAssociatedPump === ThermoAssociatedPump.Yes;
  }

  get isModeSeparate() {
    return (
      this.roomObject.actuatorModalityType === ActuatorModalityType.Separate
    );
  }

  get isModeShared() {
    return this.roomObject.actuatorModalityType === ActuatorModalityType.Shared;
  }

  get isModeMixed() {
    return this.roomObject.actuatorModalityType === ActuatorModalityType.Mixed;
  }

  get currentStepTitle() {
    return this.$t(this.steps[this.activeStep].title);
  }

  get buttonSubmitLabel() {
    if (this.activeStep < this.steps.length - 1) {
      return this.$t('AppResource.Next');
    }

    return this.$t('AppResource.SaveAndExit');
  }

  get activeStepObject() {
    return this.steps[this.activeStep];
  }

  get isHeatingGatewayMode() {
    return (
      this.roomObject.heatingSystemControlType ==
        SystemControlType.GatewayMode ||
      this.roomObject.sharedSystemControlType == SystemControlType.GatewayMode
    );
  }

  get isCoolingGatewayMode() {
    return (
      this.roomObject.coolingSystemControlType == SystemControlType.GatewayMode
    );
  }

  async created() {
    this.plantId = +this.$route.params.plantId;
    this.roomId = this.$route.params.roomId as string;
    this.roomObjectId = this.$route.params.roomObjectId as string;

    this.roomName = this.$route.query.roomName as string;
    this.roomType = +this.$route.query.roomType! as number;

    await this.fetchRoomObject();
  }

  async fetchRoomObject() {
    this.$store.dispatch(SET_APP_LOADING, true);
    this.roomObject = await plantsClient.thermoGET(
      this.plantId,
      this.roomId,
      this.roomObjectId
    );
    this.$store.dispatch(SET_APP_LOADING, false);
  }

  async handleButtonSubmitAction() {
    if (this.activeStep < this.steps.length - 1) {
      do {
        this.activeStep++;
      } while (this.steps[this.activeStep].disabled);
      return;
    }

    this.$store.dispatch(SET_APP_LOADING, true);

    const request: IEditThermoRoomObjectDTO = {
      deviceSettings: DeviceSettingsService.generateDeviceSettingsResultDto(
        this.devicesSettings
      ),
      thermoRoomObject: ThermoRoomObjectDTO.fromJS(this.roomObject),
    };

    try {
      await plantsClient.thermoPUT(
        this.plantId,
        this.roomId,
        this.roomObjectId,
        new EditThermoRoomObjectDTO(request)
      );

      this.$router.push({
        name: 'page-plant-room',
        query: { refresh: 'true' },
      });
    } catch (error) {
      let messageError = '';

      switch (error.status) {
        case 409:
          this.$emitter.emit(HANDLE_REFRESH_PLANT);
          this.$router.push({
            name: 'page-plant-dashboard',
            params: this.$route.params,
          });
          break;
        default:
          messageError = this.$t('apiErrors.serverError').toString();
      }

      if (messageError) {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('general.operationError'),
          closable: true,
          life: 3000,
        });
      }
    } finally {
      NamingService.flushCache();
      this.$store.dispatch(SET_APP_LOADING, false);
    }
  }

  handleButtonBackAction() {
    if (this.activeStep > 0) {
      this.nextDisabled = false;
      do {
        this.activeStep--;
      } while (this.steps[this.activeStep].disabled);
    } else {
      this.$router.push({ name: 'page-plant-room' });
    }
  }

  nextEnabledEvent(nextEnabled: boolean) {
    this.nextDisabled = !nextEnabled;
  }
}
